import React from 'react';
import { Trash2 } from 'lucide-react';
import { Input } from '../ui/input';
import { currency } from './shared';

const TYPE_LABEL = { time: 'Time', fixed: 'Fixed fee', disbursement: 'Disbursement' };

const LineRow = ({ line, idx, editable, onChange, onRemove }) => {
  const set = (k) => (e) => onChange(idx, { ...line, [k]: e.target.type === 'number' ? (e.target.value === '' ? '' : Number(e.target.value)) : e.target.value });
  const isTime = line.type === 'time';
  const amount = isTime || (line.hours && line.rate) ? (Number(line.hours) || 0) * (Number(line.rate) || 0) : Number(line.amount) || 0;
  return (
    <tr className="border-t border-stone-100 align-top" data-testid={`invoice-line-${idx}`}>
      <td className="px-3 py-2">
        <div className="text-[10px] uppercase tracking-wider font-semibold text-stone-400 mb-1">{TYPE_LABEL[line.type]}{line.staffName ? ` · ${line.staffName}` : ''}</div>
        {editable ? <Input value={line.description} onChange={set('description')} className="h-8 text-sm" data-testid={`invoice-line-desc-${idx}`}/> : <div className="text-sm text-stone-900">{line.description}</div>}
      </td>
      <td className="px-3 py-2 w-24">
        {isTime && editable ? <Input type="number" step="0.01" min="0" value={line.hours ?? ''} onChange={set('hours')} className="h-8 text-sm text-right" data-testid={`invoice-line-hours-${idx}`}/> : <div className="text-sm text-right pt-5">{line.hours ? Number(line.hours).toFixed(2) : ''}</div>}
      </td>
      <td className="px-3 py-2 w-28">
        {isTime && editable ? <Input type="number" step="1" min="0" value={line.rate ?? ''} onChange={set('rate')} className="h-8 text-sm text-right" data-testid={`invoice-line-rate-${idx}`}/> : <div className="text-sm text-right pt-5">{line.rate ? currency(line.rate) : ''}</div>}
      </td>
      <td className="px-3 py-2 w-32">
        {!isTime && editable ? <Input type="number" step="0.01" min="0" value={line.amount ?? ''} onChange={set('amount')} className="h-8 text-sm text-right" data-testid={`invoice-line-amount-${idx}`}/> : <div className="text-sm text-right font-medium pt-5">{currency(amount)}</div>}
      </td>
      <td className="px-3 py-2 w-20 text-center">
        {editable ? (
          <label className="inline-flex items-center gap-1 text-[11px] text-stone-500 pt-5"><input type="checkbox" checked={line.vatable} onChange={(e) => onChange(idx, { ...line, vatable: e.target.checked })} data-testid={`invoice-line-vat-${idx}`}/> VAT</label>
        ) : <div className="text-[11px] text-stone-500 pt-5">{line.vatable ? 'VAT' : 'No VAT'}</div>}
      </td>
      <td className="px-2 py-2 w-8">{editable && <button type="button" onClick={() => onRemove(idx)} className="mt-5 text-stone-400 hover:text-red-600" title={isTime ? 'Remove — hours go back to unbilled' : 'Remove line'} data-testid={`invoice-line-remove-${idx}`}><Trash2 size={14}/></button>}</td>
    </tr>
  );
};

export const lineAmount = (l) => (l.type === 'time' || (l.hours && l.rate) ? (Number(l.hours) || 0) * (Number(l.rate) || 0) : Number(l.amount) || 0);

export const LineItemsTable = ({ lines, editable, onChange, onRemove }) => (
  <div className="rounded-lg border border-stone-200 overflow-x-auto">
    <table className="w-full" data-testid="invoice-lines-table">
      <thead className="bg-stone-50 text-[11px] uppercase tracking-wider text-stone-500">
        <tr><th className="text-left px-3 py-2">Description</th><th className="text-right px-3 py-2">Hours</th><th className="text-right px-3 py-2">Rate</th><th className="text-right px-3 py-2">Amount</th><th className="px-3 py-2"/><th/></tr>
      </thead>
      <tbody>
        {lines.length === 0 && <tr><td colSpan={6} className="px-3 py-6 text-center text-sm text-stone-500">No lines yet. Add a fixed fee or pull in tracked time.</td></tr>}
        {lines.map((l, i) => <LineRow key={l.id || `new-${i}`} line={l} idx={i} editable={editable} onChange={onChange} onRemove={onRemove}/>)}
      </tbody>
    </table>
  </div>
);
